import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { CoreDataService } from '@app/core/async-services/http/core.data';
import { HEEvent, API } from '@app/core/models';
import { Platform } from '@ionic/angular';
import { environment } from '@env/environment';
import { version } from '@env/version';
import * as moment from 'moment';
import { AuthUtilityService } from '@app/core/utils';

@Injectable({
  providedIn: 'root',
})
export class HeLogHttpService {
  constructor(
    private coreDataService: CoreDataService,
    private platform: Platform,
  ) {}

  logEvent(body: { [key: string]: any }) {
    const options: API.HttpOptions = !this.platform.is('capacitor')
      ? {
          headers: new HttpHeaders().set('content-type', 'application/json'),
          withCredentials: true,
        }
      : {};
    return this.coreDataService.post(
      'static/logs',
      {
        ...body,
        clientDateTimeUTC: moment().toISOString(),
      },
      options,
    );
  }
}
